<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>Add quiz question</h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block spinner-parent">
                <spinner ref="spinner" size="md" text="Loading ..." />
                <div class="form-group row">
                  <label for="title" class="col-md-2">Question *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.question"
                      type="text"
                      placeholder="Enter question"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-2" for="default">Answer *</label>
                  <div class="col-md-10">
                    <select id="default" v-model="entity.answer" class="form-control">
                      <option :value="true">
                        True
                      </option>
                      <option :value="false">
                        False
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="bio" class="col-md-2">Explanation</label>
                  <div class="col-md-10">
                    <textarea
                      id="title"
                      v-model="entity.explanation"
                      type="text"
                      placeholder="Enter explanation"
                      class="form-control"
                    ></textarea>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="bio" class="col-md-2">More Info Text</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.more_info"
                      type="text"
                      placeholder="Enter text"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label for="bio" class="col-md-2">More Info Link</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.link"
                      type="text"
                      placeholder="Enter link"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Quiz question added successfully!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
// Mixins
import CreatePageMixin from '@/mixins/CreatePageMixin';
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';
import QuizGameMixin from '@/mixins/QuizGameMixin';

export default {
  name: 'QuizImagesNew',

  mixins: [CreatePageMixin, DefaultOptionsRequests, QuizGameMixin],

  mounted() {
    if (!this.images.length) {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.getAllImages()
        .then((response) => {
          const memoryImages = _.cloneDeep(response.data);
          delete memoryImages.meta;
          const images = Object.keys(memoryImages).map(e => memoryImages[e]);
          this.$store.dispatch('quizGame/setImages', images);
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        });
    }
  },

  methods: {
    saveRequest() {
      const postFormData = new FormData();
      postFormData.append('question', this.entity.question);
      if (this.entity.answer) {
        postFormData.append('answer', 1)
      } else {
        postFormData.append('answer', 0)
      };
      if (this.entity.explanation) {
        postFormData.append('explanation', this.entity.explanation);
      };
      if (this.entity.more_info) {
        postFormData.append('more_info', this.entity.more_info);
      };
      if (this.entity.link) {
        postFormData.append('link', this.entity.link);
      };
      return this.$apiHttp.post(`${this.$config.app_api.prefix}games/quiz`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      //if (!this.isEntityValid()) return;
      this.saveRequest().then((response) => {
        this.$_successSave();
        this.$parent.getSource();
        window.location.hash = `#/admin/quiz-game-images/edit/${response.data.id}`;
      }, (error) => {
        console.error('Error in audio create request', error);
        this.$_errorSave(error);
      });
    },
    getAllImages() {
      return this.$apiHttp.get(`${this.$config.app_api.prefix}games/quiz`, {
        params: {
          nonpaginated: true,
        },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// New.vue?31278bf3